import React from 'react'
import PropTypes from 'prop-types'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import { getEventDescription } from '../../../../../../helpers/eventDescription'
import * as Badges from '../../../../../../components/badges'

const Threshold = (props) => {
  return <tr>
    <td><Badges.Threshold /></td>
    <td>{getEventDescription(props.item, 'Threshold')}</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

Threshold.propTypes = {
  item: PropTypes.object
}

export default Threshold



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/threshold/index.js